import { css, styled } from 'canoe';

export const DefinitionFieldWrapper = styled.div`
  width: 0px;
  min-width: 100px;
  max-width: 330px;
  flex: 1 1 0px;
`;

export const SelectInputWrapper = styled(DefinitionFieldWrapper)<{ isMultiselect?: boolean }>`
  ${({ isMultiselect }) => css`
    ${isMultiselect &&
    css`
      flex-basis: 30%;
    `}
  `}
`;
